export default {
  namespaced: true,
  actions: {
    likeVendor: function ({ dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`user/like`, payload)
          .then(() => {
            return resolve(true);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  (err.data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    unlikeVendor: function ({ dispatch }, payload = {}) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete(`user/unlike/${payload.id}`)
          .then(() => {
            return resolve(true);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  (err.data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
  },
};
